import { applyTheme } from '@/utils/theme'
import { DEFAULT_THEME } from '@/styles/themes'

export default {
  namespaced: true,
  state: {
    currentLan: 'en',
    isShowTips: true,
    currentTheme: DEFAULT_THEME
  },
  mutations: {
    setLang: (state, lang) => {
      state.currentLan = lang
    },
    setShowTips: (state, showTips) => {
      state.isShowTips = showTips
    },
    setTheme: (state, themeName) => {
      state.currentTheme = themeName
    }
  },
  actions: {
    setLang: ({ commit }, lang) => {
      commit('setLang', lang)
    },
    setShowTips: ({ commit }, showTips) => {
      commit('setShowTips', showTips)
    },
    applyTheme: ({ commit }, themeName) => {
      commit('setTheme', themeName)
      applyTheme(themeName)
      sessionStorage.setItem('theme', themeName)
    }
  }
}
